<meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
<meta http-equiv="Pragma" content="no-cache">
<meta http-equiv="Expires" content="0">

<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>

<!-- DESIGN MODE -->
@if (this.IsInDesignMode) {
  <div class="grid-design-div" data-grid-type="grid">
    <!-- Display my label. -->
    @if (this.DisplayName) {
      <div class="design-mode-field-label">{{this.DisplayName}}</div>
    }
    <!-- Define a place to inject instructions, if any. -->
    <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
    <app-grid-field-designer [gridFormFieldComponent]="this"></app-grid-field-designer>
    <!-- Define a design mode menu. -->
    <mat-menu #gridCellContextMenu="matMenu">
      <ng-template matMenuContent let-row="row">
        <button mat-menu-item
          [disabled]="false"
          (click)="this.gridCellContextMenuItemClicked($event,'Properties ...')">
          Properties ...
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item
          [disabled]="false"
          (click)="this.gridCellContextMenuItemClicked($event,'Delete')">
          Delete
        </button>
      </ng-template>
    </mat-menu>
    <!-- Define a menu trigger. -->
    <div style="visibility: hidden; position: fixed"
      [style.left]="this.ContextMenuPositionX"
      [style.top]="this.ContextMenuPositionY"
      [matMenuTriggerFor]="gridCellContextMenu">
    </div>
  </div>
}

<!-- PREVIEW/INSTANCE MODE -->
@if (this.IsInPreviewOrInstanceMode) {
  <div class="preview-and-instance-modes-div" data-grid-type="grid">
    @if (this.DisplayName) {
      <div class="field-label">{{this.DisplayName}}</div>
    }
    <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
    <app-grid-field-editor [formInstance]="FormInstance"
      [gridFormFieldComponent]="this"
      [isFootnotesGrid]="isFootnotesGrid"
      (editorGridValidation)="this.handleEditorGridValidation($event)"
    (conditionalLogicColumnDefsFilter)="this.handleConditionalLogicColumnDefsFilter($event)"></app-grid-field-editor>
  </div>
}
